import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import { DeleteQueryHistoryBulkResponse, MutationDeleteQueryHistoryBulkArgs } from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import DeleteQueryHistoryBulk from '@/features/DriveTimeTool/api/queries/DeleteQueryHistoryBulk';
import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';

// Service Function Signature
type ServiceMethodPayload = string[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteQueryHistoryBulkResponse>;
}

// DeleteQueryHistoryBulk Service
export const { deleteQueryHistoryBulk, useDeleteQueryHistoryBulk } = ((): {
  deleteQueryHistoryBulk: ServiceMethod;
  useDeleteQueryHistoryBulk: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(DeleteQueryHistoryBulk).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteQueryHistoryBulkResponse> => {
        const args: MutationDeleteQueryHistoryBulkArgs = {
          input: {
            search: payload.map((id) => ({ id })),
          },
        };
        const opts = { merge: options?.merge ? 'deleteQueryHistoryBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('deleteQueryHistoryBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    deleteQueryHistoryBulk: fetch,
    useDeleteQueryHistoryBulk: useService,
  };
})();
